<template>
<div>
    <!--
    <div class="row" v-if="groupResourcesAsProducts">
        <additional-product-resource-selector :products="singularMandatoryProducts" />
        <div class="clearfix"></div>
        <additional-resource 
            class="col-xs-12 col-sm-6 col-md-4"
            v-for="(row, index) in selectedAdditionalResources"
            :key="index"
            :resource="row" />
    </div>
    -->
    <div class="row" v-if="groupResourcesAsProducts">
        <div class="col-xs-12 col-sm-6 col-md-4"
            v-for="(row, productId) in singularMandatoryProducts"
            :key="productId">
            <additional-product-resource 
                :productResource="row"
                :singular="true" />
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4"
            v-for="(row, productId) in mandatoryProducts"
            :key="productId">
            <additional-product-resource 
                :productResource="row" />
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4"
            v-for="(row, productId) in products"
            :key="productId">
            <additional-product-resource 
                :productResource="row" />
        </div>
    </div>
    <div class="row" v-if="!groupResourcesAsProducts">
        <additional-resource 
            class="col-xs-12 col-sm-6 col-md-4"
            v-for="(row, index) in availableAdditionalResources"
            :key="index"
            :resource="row" />
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
//import AdditionalProductResourceSelector from './AdditionalProductResourceSelector.vue'
import AdditionalProductResource from './AdditionalProductResource.vue'
import AdditionalResource from './AdditionalResource.vue'

const reduceToProducts = (prev, curr) => {
    const { productId, productName, productDescription } = curr;

    if (typeof prev[productId] === 'undefined') {
        prev[curr.productId] = {
            productId, 
            productName, 
            productDescription,
            resources: [ curr ] 
        }
    } else {
        prev[curr.productId].resources.push(curr)
    }
    
    return prev;
}

export default {
    components: {
        //AdditionalProductResourceSelector,
        AdditionalProductResource,
        AdditionalResource,
    },
    data: () => ({
        selectedProductResource: {},
    }),
    computed: {
        ...mapGetters({
            availableAdditionalResources: 'calendar/availableAdditionalResources',
            selectedAdditionalResources: 'calendar/selectedAdditionalResources',
            additionalResourceQuantity: 'calendar/additionalResourceQuantity',
            reservationSettings: 'reservations/settings',
        }),
        mandatoryResources() {
            return this.availableAdditionalResources.filter(row => row.minQuantity > 0 && row.maxQuantity > 1);
        },
        singularMandatoryResources() {
            return this.availableAdditionalResources.filter(row => row.minQuantity > 0 && row.maxQuantity === 1);
        },
        resources() {
            return this.availableAdditionalResources.filter(row => row.minQuantity === 0);
        },
        mandatoryProducts() {
            return this.mandatoryResources.reduce(reduceToProducts, {})
        },
        singularMandatoryProducts() {
            return this.singularMandatoryResources.reduce(reduceToProducts, {})
        },
        products() {
            return this.resources.reduce(reduceToProducts, {})
        },
        groupResourcesAsProducts() {
            const { groupResourcesAsProducts } = this.reservationSettings;

            return !!groupResourcesAsProducts;
        },
    },
    methods: {
        isMandatoryProductsSelected() {
            // if resources are not grouped, no reason to check
            if (!this.groupResourcesAsProducts) {
                return true;
            }

            const selectedResourceIds = this.selectedAdditionalResources.map(row => row.resourceId);
            const mandatoryProducts = Object.keys(this.mandatoryProducts).map(key => this.mandatoryProducts[key]);
            const singularMandatoryProducts = Object.keys(this.singularMandatoryProducts).map(key => this.singularMandatoryProducts[key]);
            const products = [...mandatoryProducts, ...singularMandatoryProducts];

            // if there aren't any, just pass
            if (products.length === 0) {
                return true;
            }
            
            let success = true;

            for(let i = 0;i < products.length;i++) {
                const found = products[i].resources.filter(row => selectedResourceIds.includes(row.resourceId));

                if (found.length === 0) {
                    success = false;
                    break;
                }
            }

            return success;
        },
        isMandatoryResourcesSelected() {
            if (!!this.groupResourcesAsProducts) {
                return true;
            }

            const selectedResourceIds = this.selectedAdditionalResources.map(row => row.resourceId);
            const resources = [...this.mandatoryResources, ...this.singularMandatoryResources];

            // if there aren't any, just pass
            if (resources.length === 0) {
                return true;
            }

            const found = resources.filter(row => selectedResourceIds.includes(row.resourceId));

            return found.length > 0;
        },
    },
}
</script>